"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SafeAreaContainer = void 0;
const react_1 = __importStar(require("react"));
require("./SafeAreaContainer.scss");
const SafeAreaContainer_scss_json_1 = __importDefault(require("./SafeAreaContainer.scss.json"));
const core_1 = require("@capacitor/core");
const capacitor_plugin_safe_area_1 = require("capacitor-plugin-safe-area");
const ClassNames_1 = require("lincd/lib/utils/ClassNames");
const SafeAreaContainer = ({ children, color, resetTop = false, resetBottom = false, }) => {
    /**
     * apply safearea for ios
     * ? should apply for android?
     */
    (0, react_1.useEffect)(() => {
        if (core_1.Capacitor.isNativePlatform() && core_1.Capacitor.getPlatform() === 'ios') {
            capacitor_plugin_safe_area_1.SafeArea.getSafeAreaInsets().then(({ insets }) => {
                for (const [key, value] of Object.entries(insets)) {
                    document.documentElement.style.setProperty(`--safe-area-${key}`, `${value}px`);
                }
            });
        }
    }, []);
    // check has color
    const hasColor = color ? { backgroundColor: color } : {};
    return (react_1.default.createElement("div", { className: (0, ClassNames_1.cl)(SafeAreaContainer_scss_json_1.default.root, resetTop && SafeAreaContainer_scss_json_1.default.resetTop, resetBottom && SafeAreaContainer_scss_json_1.default.resetBottom) },
        !resetTop && (react_1.default.createElement("div", { className: (0, ClassNames_1.cl)(SafeAreaContainer_scss_json_1.default.safearea, SafeAreaContainer_scss_json_1.default['top']), style: hasColor })),
        react_1.default.createElement("div", null, children),
        !resetBottom && (react_1.default.createElement("div", { className: (0, ClassNames_1.cl)(SafeAreaContainer_scss_json_1.default.safearea, SafeAreaContainer_scss_json_1.default['bottom']), style: hasColor }))));
};
exports.SafeAreaContainer = SafeAreaContainer;
//# sourceMappingURL=SafeAreaContainer.js.map